export const API = 'API';
export const API_START = 'API_START';
export const API_END = 'API_END';
export const ACCESS_DENIED = 'ACCESS_DENIED';
export const API_ERROR = 'API_ERROR';

export const apiStart = (label, requestStartTime, apiActionPayload = {}) => ({
    type: API_START,
    payload: {
        label,
        requestStartTime,
        ...apiActionPayload,
    },
});

export const apiEnd = (label, requestStartTime, apiActionPayload = {}) => ({
    type: API_END,
    payload: {
        label,
        requestStartTime,
        ...apiActionPayload,
    },
});

// todo: handling duplicate inflight requests
export const accessDenied = (url) => ({
    type: ACCESS_DENIED,
    payload: {
        url,
    },
});

export const apiError = (error) => ({
    type: API_ERROR,
    error,
});

//todo: we probably don't need to use accessToken b/c it is baked in, but leaving it for now just in case
export function apiAction({
    url = '',
    method = 'GET',
    data = null,
    accessToken = null,
    onSuccess = () => {},
    onFailure = () => {},
    onFailureAction = null,
    label = '',
    headersOverride = null,
    withCredentials = true,
    apiActionPayload = {},
}) {
    return {
        type: API,
        payload: {
            url,
            method,
            data,
            accessToken,
            onSuccess,
            onFailure,
            onFailureAction,
            label,
            headersOverride,
            withCredentials,
            apiActionPayload,
        },
    };
}
